module.exports = __webpack_public_path__ + "../resources/img/line_checkbox_unselected_hover.261fb380.svg";